<template>
  <b-form-group :label="label" :label-for="id">
    <b-form-input class="form-control" :id="id" :name="id" v-model="content" v-mask="maskVal" placeholder="(xxx) xxx-xxxx"
      type="tel" :state="v && v.$error ? false : null" @input="v && v.$touch()" />
    <b-form-invalid-feedback v-if="submitted && v && v.$dirty && !v.required" :name="id">{{ label }} is
      required</b-form-invalid-feedback>
    <b-form-invalid-feedback v-if="submitted && v && v.$dirty && !v.minLength" name="id">{{ label }} needs to be 10
      digits</b-form-invalid-feedback>
    <b-form-invalid-feedback v-if="submitted && v && v.$dirty && !v.maxLength" name="id">{{ label }} needs to be 10
      digits</b-form-invalid-feedback>
  </b-form-group>
</template>

<script>
import { maxLength, minLength, required } from 'vuelidate/lib/validators';
import { formatPhoneNumber, hasUSCountryCode } from '../lib/functions/phoneNumber';

export default {
  props: {
    label: {
      type: String,
      required: false,
      default: 'Telephone *',
    },
    id: {
      type: String,
      required: false,
      default: 'telephone',
    },
    placeholder: {
      type: String,
      required: false,
      default: 'Telephone',
    },
    value: {
      type: String,
      required: true,
      default: null,
    },
    v: {
      type: Object,
      required: false
    },
    submitted: {
      type: Boolean,
      required: false,
      default: false,
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  validations: {
    value: {
      required,
      minLength: minLength(14),
      maxLength: maxLength(17),
    },
  },
  data() {
    return {
      internalValue: formatPhoneNumber(this.value),
    };
  },
  computed: {
    content: {
      get() {
        return this.internalValue;
      },
      set(val) {
        this.internalValue = val;
        this.$emit('input', val);
      },
    },
    maskVal: {
      get() {
        return hasUSCountryCode(this.content) ? '+# (###) ###-####' : '(###) ###-####';
      },
    },
  },
  watch: {
    value: {
      handler(val) {
        this.content = val;
      },
      immediate: true,
    },
  },

  methods: {
    handleInput(e) {
      this.$emit('input', e.target.value);
    },
  }
};
</script>
